import React, { Fragment } from "react";
import SideBar from "./SideBar";

const JobieNav = ({ companyId }) => {
  return (
    <Fragment>
      <SideBar companyId={companyId} />
    </Fragment>
  );
};

export default JobieNav;
